import {Timestamps} from "types/common"

export enum DuplicatedLeadNotificationCampusOption {
    ALL_CAMPUSES = "all_campuses",
    SINGLE_CAMPUS = "single_campus",
    NO_CAMPUS = "no_campus"
}

export enum DuplicatedLeadNotificationCampusLabel {
    ALL_CAMPUSES = "All Campuses",
    SINGLE_CAMPUS = "Single Campus",
    NO_CAMPUS = "No Campus"
}

export const DuplicatedLeadNotificationCampusMap = {
    [DuplicatedLeadNotificationCampusLabel.ALL_CAMPUSES]: DuplicatedLeadNotificationCampusOption.ALL_CAMPUSES,
    [DuplicatedLeadNotificationCampusLabel.NO_CAMPUS]: DuplicatedLeadNotificationCampusOption.NO_CAMPUS,
    [DuplicatedLeadNotificationCampusLabel.SINGLE_CAMPUS]: DuplicatedLeadNotificationCampusOption.SINGLE_CAMPUS
}

export type AddDuplicatedLeadNotificationRecipientPayload = {
    recipientProfileId: number[]
    receiveNotificationsFor: DuplicatedLeadNotificationCampusOption
    campusId: number | null
}

export type ListDuplicatedLeadNotificationRecipientsPayload = {
    filter?: Partial<{}>
    range?: {
        page: number
        pageSize: number
    }
    sort?: {
        orderBy: keyof DuplicatedLeadNotificationRecipientItem
        orderDir: "asc" | "desc" | "ASC" | "DESC"
    }
}

export type UpdateDuplicatedLeadNotificationRecipientPayload = {
    recipientProfileId: number[]
    receiveNotificationsFor: DuplicatedLeadNotificationCampusOption
    campusId: number | null
}

export type DeleteDuplicatedLeadNotificationRecipientPayload = {
    campusId: number | null
    receiveNotificationsFor: DuplicatedLeadNotificationCampusOption
}

export type DuplicatedLeadNotificationRecipientBase = {
    recipientProfileId: number
    campusId: number
    receiveNotificationsFor: DuplicatedLeadNotificationCampusOption
} & Timestamps

export type DuplicatedLeadNotificationRecipientItem = DuplicatedLeadNotificationRecipientBase & {
    campusName: string
    users: {
        profileId: number
        name: string
    }[]
    campus: {
        id: number | string
        name: string
    }
}

export type DuplicatedLeadNotificationRecipientResponse = {
    data: DuplicatedLeadNotificationRecipientItem[]
    total: number
}
